import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { CodeSnippet } from '@backstage/core-components';
import { groupLinkTranslationsRef } from './translations.ts';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

const ENTITY_YAML = `apiVersion: tblx.io/v1alpha1
kind: GroupLinks
metadata:
  name: example-group-links
spec:
  groupName: example-group
  links:
    - title: Jira Board
      url: https://jira.com/example-group/board
      type: jira
      icon: dashboard
    - title: Roadmap
      url: https://roadmap.sh/frontend
      type: roadmap
      icon: dashboard
`;

/** @public */
export type EntityGroupLinksEmptyStateClassKey = 'code';

const useStyles = makeStyles(
  theme => ({
    code: {
      borderRadius: 6,
      margin: theme.spacing(2, 0),
      background:
        theme.palette.type === 'dark' ? '#444' : theme.palette.common.white,
    },
  }),
  { name: 'PluginCatalogEntityGroupLinksEmptyState' },
);

export function EntityGroupLinksEmptyState() {
  const classes = useStyles();
  const { t } = useTranslationRef(groupLinkTranslationsRef);

  return (
    <>
      <Typography variant="body1">{t('noLinksText')}</Typography>
      <div className={classes.code}>
        <CodeSnippet
          text={ENTITY_YAML}
          language="yaml"
          showLineNumbers
          highlightedNumbers={[6]}
          customStyle={{ background: 'inherit', fontSize: '115%' }}
        />
      </div>
    </>
  );
}
